import { Component, OnInit } from "@angular/core";
import { AuthService } from "../_services/auth/auth.service";

import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Store } from "@ngrx/store";
import { User } from "../_models/user-models/user";
import { AlertifyService } from "../_services/common/alertify.service";
import { AppSessionState } from "../_services/common/app.service";
import { login } from "../_store/actions/login.actions";
import { UserSessionStateModel } from "../_store/models/user-session-state.model";
//loginModel
import { FormBuilder, FormGroup } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { environment } from "../../environments/environment";
import { Configuration } from "../_core/models/configuration.model";
import { ConfigurationService } from "../_core/services/configuration.service";
import { passwordValidator } from "../_helper/password.validator";
import { emailValidator } from "../_helper/validator.helper";
import {
  CaptchaValidationModel,
  GeneralResModel,
  LoginExceptionModel,
  LoginModel,
  MenuItem,
  RecaptchaRequestModel,
  RecaptchaResponseModel,
} from "../_models";
import { CommonResponse } from "../_models/common-response.modle";
import { MessageConstant } from "../_models/shared/message.constant";
import {
  AppMenuService,
  BrowserInfoService,
  CustomNavigationService,
  LocalStorageService,
  SignalrService,
} from "../_services";
import { DataService } from "../_services/data-service/data.service";
import { AppConstant } from "../shared/webdatarocks/app.constant";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  dark: boolean;
  checked: boolean;
  loginModel: any = {};
  client: User;
  showSpinner: boolean;
  loaderVisible: boolean = false;
  isDisabled: boolean = false;
  isCloud: boolean = true;
  menuData: MenuItem[] = [];
  getUser: User = new User();

  captchaKey: string = "";
  captchaBase64: string = "";
  userCaptcha: string = "";
  message: string = "";
  failedAttempts: number = 0;
  recaptchaToken: string = "";
  siteKey: string = environment.recaptcha.siteKey;
  recaptchaRequest: RecaptchaRequestModel = new RecaptchaRequestModel();
  recaptchaResponse: RecaptchaResponseModel = new RecaptchaResponseModel();
  loginExceptionData: LoginExceptionModel = new LoginExceptionModel();
  captchaValidationModel: CaptchaValidationModel = new CaptchaValidationModel();
  config: Configuration = new Configuration();
  isSkipLocation: boolean = environment.isSkipLocation;

  _loginForm!: FormGroup;
  loginRequestModel: LoginModel = new LoginModel();

  constructor(
    private router: Router,
    private _fb: FormBuilder,
    private store: Store<any>,
    private authService: AuthService,
    private _dataService: DataService,
    private _appMenuService: AppMenuService,
    private _signalrService: SignalrService,
    private appSessionState: AppSessionState,
    private _alertifyService: AlertifyService,
    private jwtHelperService: JwtHelperService,
    private _browserInfoService: BrowserInfoService,
    private _confirmationService: ConfirmationService,
    private configurationService: ConfigurationService,
    private customNavigationService: CustomNavigationService
  ) { }

  ngOnInit() {
    this.basicInit();
  }

  private basicInit() {
    this.loginFormInit();
    LocalStorageService.removeAllStorageValue();

    this.isCloud = environment.isCloud;
    environment.isSiteAdmin = false;
    if (this.jwtHelperService.isTokenExpired(localStorage.getItem("token"))) {
      this.router.navigate(["/login"]);
    } else {
      this.routeToStudyWorklist();
    }

    this.configurationService.getJSONwithAPI().subscribe((res) => {
      this.config = res as Configuration;

      if (!this.config.setting.IsInternetAllow) {
        this.onRefreshCaptcha();
      }
    });
  }

  private loginFormInit() {
    this._loginForm = this._fb.group({
      UserEmail: ["", emailValidator],
      Password: ["", passwordValidator],
      IsCloud: [false, []],
    });
  }

  async onSubmit() {
    if (this.failedAttempts > 2) {
      this._alertifyService.error(
        "First, verify the Captcha! Please try again."
      );
      return;
    }

    if (this._loginForm?.invalid) {
      this._alertifyService.error(MessageConstant.InvalidUserAndPass);
      return;
    }

    this.loaderVisible = true;
    this.loginRequestModel = this._loginForm?.value;

    await this.receiveMessage();

    let deviceInfo = this._browserInfoService.getDeviceInfo();
    await this._browserInfoService.getBrowserMetaData().subscribe({
      next: (data) => {
        if (data) {
          this.loginRequestModel.BrowserMetaData = data;
          this.loginRequestModel.BrowserMetaData.browser = deviceInfo.browser;
          this.loginRequestModel.BrowserMetaData.os = deviceInfo.os;
          this.loginRequestModel.BrowserMetaData.deviceType =
            deviceInfo.deviceType;
          this.loginRequestModel.BrowserMetaData.orientation =
            deviceInfo.orientation;
          this.authService
            .isDuplicateUserCheck(this.loginRequestModel)
            .subscribe({
              next: (data: any) => {
                if (data.IsSucceed) {
                  this.getUser = data.Result;

                  if (this.getUser.IsDuplicate) {
                    this.loaderVisible = false;
                    if (this.config.setting.IsInternetAllow) {
                      // Internet Allow
                      this._confirmationService.confirm({
                        key: "CheckDuplicateUser",
                        message: `There is already a login with this user at ${this.getUser.PreviousUserSession.UserCountry}/ ${this.getUser.PreviousUserSession.UserCity}, do you want replace that session?`,
                        accept: () => {
                          this.loginSubmit(this.getUser.IsDuplicate);
                        },
                        reject: () => {
                          return;
                        },
                      });
                    } else {
                      this._confirmationService.confirm({
                        key: "CheckDuplicateUser",
                        message: `There is already a login with this user, do you want replace that session?`,
                        accept: () => {
                          this.loginSubmit(this.getUser.IsDuplicate);
                        },
                        reject: () => {
                          return;
                        },
                      });
                    }
                  } else {
                    this.loginSubmit(this.getUser.IsDuplicate);
                  }
                } else {
                  this.loginExceptionData = data.Result;
                  if (
                    this.loginExceptionData &&
                    this.loginExceptionData.FailedAttempCount > 0
                  ) {
                    this.setFailedAttempts(
                      this.loginExceptionData.FailedAttempCount
                    );
                  }
                  this.errorMessageShow(data.HttpStatusCode);
                  this.loaderVisible = false;
                }
              },
              error: (error) => {
                //console.log(error);
              },
            });
        }
      },
      error: (err) => {
        this.authService
          .isDuplicateUserCheck(this.loginRequestModel)
          .subscribe({
            next: (data: any) => {
              if (data.IsSucceed) {
                this.getUser = data.Result;

                if (this.getUser.IsDuplicate) {
                  this.loaderVisible = false;
                  this._confirmationService.confirm({
                    key: "CheckDuplicateUser",
                    message: `Their is already a login with this user at ${this.getUser.PreviousUserSession.UserCountry}/ ${this.getUser.PreviousUserSession.UserCity}, do you want replace that session?`,
                    accept: () => {
                      this.loginSubmit(this.getUser.IsDuplicate);
                    },
                    reject: () => {
                      return;
                    },
                  });
                } else {
                  this.loginSubmit(this.getUser.IsDuplicate);
                }
              } else {
                this.loginExceptionData = data.Result;
                if (
                  this.loginExceptionData &&
                  this.loginExceptionData.FailedAttempCount > 0
                ) {
                  this.setFailedAttempts(
                    this.loginExceptionData.FailedAttempCount
                  );
                }
                this.errorMessageShow(data.HttpStatusCode);
                this.loaderVisible = false;
              }
            },
            error: (error) => {
              //console.log(error);
            },
          });
      },
    });
  }

  async receiveMessage() {
    // this.signalrService.startConnection();
    this._signalrService.receiveDuplicateUser(
      (userId, sessionGuid, code) => {
        var user = LocalStorageService.getUserStorageValue();
        if (
          code === '409' &&
          user.EmpId.toString() === userId &&
          sessionGuid != user.SessionGuid
        ) {
          LocalStorageService.removeAllStorageValue();
          //   window.location.reload();
          this._alertifyService.warning(
            'Your Session has been replaced.'
          );
          setTimeout(function () {
            window.location.reload();
          }, 3000); // 5000 milliseconds = 5 seconds
          //   console.log("Someone tries to login!");
        }
      }
    );
  }

  // loginSubmit() {
  //   if (this.failedAttempts > 2) {
  //     this._alertifyService.error(
  //       "First, verify the Captcha! Please try again."
  //     );
  //     return;
  //   }

  //   this.loaderVisible = true;
  //   this.loginModel.IsCloud = this.isCloud;
  //   this._dataService.sharedLoginReqData = this.loginModel;
  //   this.authService.login(this.loginModel).subscribe(
  //     (data) => {
  //       if (data.IsSucceed) {
  //         this.getUser = data.Result;
  //         if (this.getUser.IsSuperAdmin) {
  //           environment.isSuperAdmin = true;
  //         }

  //         if (this.getUser.JobType == "A") {
  //           environment.isSiteAdmin = true;
  //         }
  //         this.appSessionState.setToken(
  //           this.getUser.TokenString,
  //           <User>this.getUser,
  //           "" + new Date()
  //         );

  //         this.appSessionState.setUserToSessionStorage(this.getUser);
  //         localStorage.setItem("immediateReport", "true");
  //         this.setUserSessionState(data);
  //         this.client = JSON.parse(localStorage.getItem("user"));

  //         if (this.client.EmpId > 0) {
  //           this.getMenuList(this.client.EmpId);
  //         }

  //         this.loaderVisible = false;
  //       } else {
  //         this.onRefreshCaptcha();
  //         this.loginExceptionData = data.Result;
  //         if (
  //           this.loginExceptionData &&
  //           this.loginExceptionData.FailedAttempCount > 0
  //         ) {
  //           this.setFailedAttempts(this.loginExceptionData.FailedAttempCount);
  //         }

  //         this.errorMessageShow(data.HttpStatusCode);
  //         this.loaderVisible = false;
  //       }
  //     },
  //     (error) => {
  //       this.loaderVisible = false;
  //       this._alertifyService.error("Failed to login");
  //     }
  //   );
  // }

  loginSubmit(isDuplicate: boolean) {
    this.authService.login(this.loginRequestModel).subscribe({
      next: (data: any) => {
        this.loaderVisible = false;

        if (data.IsSucceed) {
          this.getUser = data.Result;
          if (isDuplicate) {

            this.checkDuplicate();
          }
          else {
            this.localStorageSetVal();
          }
        } else {
          this.onRefreshCaptcha();
          this.loginExceptionData = data.Result;
          if (
            this.loginExceptionData &&
            this.loginExceptionData.FailedAttempCount > 0
          ) {
            this.setFailedAttempts(this.loginExceptionData.FailedAttempCount);
          }

          this.errorMessageShow(data.HttpStatusCode);
        }
      },
      error: (error) => {
        this.loaderVisible = false;
      },
    });
  }

  checkDuplicate() {
    this.authService
      .userDuplicateCheck(this.getUser.EmpId)
      .subscribe((res) => {
        if (res.IsSucceed) {
          this.localStorageSetVal();
        }
      });
  }

  localStorageSetVal() {
    sessionStorage.setItem(AppConstant.LoginToken, this.getUser.TokenString);
    LocalStorageService.setStorageValue(
      AppConstant.LoginToken,
      this.getUser.TokenString
    );

    localStorage.setItem(AppConstant.LoginToken, this.getUser.TokenString);
    LocalStorageService.setStorageValueWithStringify(
      AppConstant.USER,
      this.getUser
    );
    const loginTime = new Date().toString();
    LocalStorageService.setStorageValue(AppConstant.LOGIN_TIME, loginTime);

    this.loaderVisible = false;
    this.client = LocalStorageService.getUserStorageValue();

    this.getMenuList(this.client.EmpId);
  }

  setUserSessionState(data) {
    let loginModel: UserSessionStateModel = {
      LoginTime: new Date(),
      UserInfo: data.user,
    };
    this.store.dispatch(login({ userSessionDetail: loginModel }));
  }

  routeToStudyWorklist() {
    this.router.navigate(["/study/worklist"]);
  }

  showLoadingSpinner() {
    this.showSpinner = true;
    this.isDisabled = true;
  }

  hideLoadingSpinner() {
    this.showSpinner = false;
    this.isDisabled = false;
  }

  goToLink() {
    window.open("https://" + environment.OAuthUrl, "_self");
  }

  gotoForgetPassword() {
    this.router.navigate(["/reset-password/radiologist"]);
  }

  private routeToTwoFAVerify() {
    this.router.navigate(["/two-factor-auth-verify"]);
  }

  private getMenuList(empId: number) {
    this._appMenuService
      .getMenuList(empId)
      .subscribe((res: GeneralResModel<MenuItem[]>) => {
        if (res.IsSucceed) {
          this.menuData = res.Result;

          this.menuData = this.menuData.map((item) => {
            return this.setMenuItemsNullIfEmpty(item);
          });

          localStorage.setItem("MENU", JSON.stringify(this.menuData));

          if (this.menuData.length > 0) {
            if (this.client.Is2faenable) {
                            LocalStorageService.setStorageValueWithStringify(
                                AppConstant.LoginRequestModel,
                                this.loginRequestModel
                            );
                            this.routeToTwoFAVerify();
                        } else {
              let defaultURL =
                this.client.LandingPageUrl ||
                this.menuData.find((x) =>
                  x.routerLink?.includes("/study/worklist")
                )?.routerLink?.[0] ||
                this.menuData[0]?.routerLink?.[0];

              if (defaultURL) {
                this.routeToLandingPage(defaultURL);
              }
            }
          } else {
            this._alertifyService.error(
              "You do not have permission to access the menu. Please contact the administrator."
            );
          }
        }
      });
  }

  private setMenuItemsNullIfEmpty(item: any): any {
    if (item.items && item.items.length === 0) {
      item.items = null;
    } else if (item.items && item.items.length > 0) {
      item.items = item.items.map((subItem) => {
        return this.setMenuItemsNullIfEmpty(subItem);
      });
    }
    return item;
  }

  private routeToLandingPage(url: string | null | undefined): void {
    const defaultRoute = "/study/order";

    const route = url?.trim().toLowerCase() || defaultRoute;

    if (this.isSkipLocation) {
      // In production, apply skipLocationChange to hide the URL
      this.customNavigationService.navigate(route).then(() => {
        // Update the address bar to root after navigating to hide internal routes
        window.history.replaceState({}, "", "/");
        this._alertifyService.success("Logged in successfully.");
      });
    } else {
      // In development, navigate normally and show the full URL for debugging
      this.customNavigationService.navigate(route).then(() => {
        this._alertifyService.success("Logged in successfully.");
      });
    }
  }

  onRefreshCaptcha() {
    this.authService.refreshCaptcha().subscribe({
      next: (res: any) => {
        this.captchaBase64 = res.imageBase64;
        this.captchaKey = res.captchaKey;
        this.userCaptcha = "";
        this.captchaValidationModel = new CaptchaValidationModel();
      },
      error: (error) => {
        console.error("Error refreshing captcha:", error);
      },
    });
  }

  verifyRecaptcha() {
    this.loaderVisible = true;

    if (!this.recaptchaToken || this.recaptchaToken.trim() === "") {
      this._alertifyService.error("Please complete the reCAPTCHA");
      this.loaderVisible = false;
      return;
    }

    this.recaptchaRequest = new RecaptchaRequestModel();
    this.recaptchaRequest.RecaptchaToken = this.recaptchaToken;

    this.authService.verifyRecaptcha(this.recaptchaRequest).subscribe({
      next: (res: GeneralResModel<RecaptchaResponseModel>) => {
        this.loaderVisible = false;

        if (res.IsSucceed) {
          const recaptchaData = res.Result;

          if (recaptchaData.IsSuccessStatusCode) {
            this._alertifyService.success("reCAPTCHA verified successfully.");
            this.recaptchaResponse = new RecaptchaResponseModel();
            this.recaptchaRequest = new RecaptchaRequestModel();
            this.failedAttempts = 0;
          } else {
            this._alertifyService.error("reCAPTCHA verification failed.");
          }
        } else {
          this._alertifyService.error("Verification failed");
        }
      },
      error: (err) => {
        this.loaderVisible = false;
        this._alertifyService.error(
          "Server error during reCAPTCHA verification"
        );
        console.error(err);
      },
    });
  }

  onCaptchaValidation() {
    if (
      !this.userCaptcha ||
      this.userCaptcha.trim() === "" ||
      this.captchaKey === ""
    ) {
      this._alertifyService.error("Please enter the CAPTCHA");
      return;
    }
    const userCaptcha: string = this.userCaptcha.trim();
    this.captchaValidationModel.UserCaptchaCode = userCaptcha;
    this.captchaValidationModel.CaptchaKey = this.captchaKey;

    this.authService.captchaValidate(this.captchaValidationModel).subscribe({
      next: (res: CommonResponse) => {
        if (res.Result) {
          this.userCaptcha = "";
          this.failedAttempts = 0;
          this.captchaBase64 = "";
          this._alertifyService.success("CAPTCHA validated successfully");
        } else {
          this.userCaptcha = "";
          this._alertifyService.error("CAPTCHA validation failed");
        }
      },
      error: (error) => {
        this.userCaptcha = "";
        this._alertifyService.error("CAPTCHA validation failed");
      },
    });
  }

  onRecaptchaResolved(token: string) {
    this.recaptchaToken = token;

    if (this.recaptchaToken || this.recaptchaToken.trim() !== "") {
      this.verifyRecaptcha();
    }
  }

  onRecaptchaError() {
    this.recaptchaToken = "";
    this.message = "reCAPTCHA verification failed. Please try again.";
  }

  private setFailedAttempts(data: any): void {
    this.failedAttempts = data;
  }

  errorMessageShow(statusCode: any) {
    this.loaderVisible = false;
    if (statusCode === 404) {
      this._alertifyService.error("User does not exist");
    } else if (statusCode === 401) {
      // this._alertifyService.error("Incorrect password");
      this._alertifyService.error(
        "Incorrect username or password. Number of failed attempts: " +
        this.failedAttempts
      );
    } else if (statusCode === 403) {
      this._alertifyService.error(
        this.getRetryMessage(this.loginExceptionData.RemainingSecond || 0)
      );
    } else {
      this._alertifyService.error("Unexpected error");
    }
  }

  private getRetryMessage(remainingSecond: number): string {
    if (remainingSecond <= 0) {
      return "You can try again now.";
    }
    const minutes = Math.floor(remainingSecond / 60);
    const seconds = remainingSecond % 60;

    // Optional: Pluralization
    const minLabel = minutes === 1 ? "min" : "min";
    const secLabel = seconds === 1 ? "sec" : "sec";

    return `Too many tries. Please try again in ${minutes} ${minLabel} ${seconds} ${secLabel}.`;
  }
}
